import { notification } from 'antd';
import i18next from 'i18next';
import sanitizeHTML from 'sanitize-html';
import {
  requestApiPost,
  requestApiGet,
  requestApiPut,
  requestApiDelete
} from 'Parts/common/requestUtils';

import { getSessionIp } from 'Parts/session/sessionUtils';

export const FETCH_UNREAD_START = 'FETCH_UNREAD_START';
export const FETCH_UNREAD_SUCCESS = 'FETCH_UNREAD_SUCCESS';
export const FETCH_UNREAD_ERROR = 'FETCH_UNREAD_ERROR';

export const SEND_MESSAGE_START = 'SEND_MESSAGE_START';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

export const BLOCK_USER_START = 'BLOCK_USER_START';
export const BLOCK_USER_SUCCESS = 'BLOCK_USER_SUCCESS';
export const BLOCK_USER_ERROR = 'BLOCK_USER_ERROR';

export const UNBLOCK_USER_START = 'UNBLOCK_USER_START';
export const UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS';
export const UNBLOCK_USER_ERROR = 'UNBLOCK_USER_ERROR';

export const FETCH_CONVERSATION_START = 'FETCH_CONVERSATION_START';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_ERROR = 'FETCH_CONVERSATION_ERROR';

export const MARK_AS_UNREAD_START = 'MARK_AS_UNREAD_START';
export const MARK_AS_UNREAD_SUCCESS = 'MARK_AS_UNREAD_SUCCESS';
export const MARK_AS_UNREAD_ERROR = 'MARK_AS_UNREAD_ERROR';

export const REPORT_MESSAGE_START = 'REPORT_MESSAGE_START';
export const REPORT_MESSAGE_SUCCESS = 'REPORT_MESSAGE_SUCCESS';
export const REPORT_MESSAGE_ERROR = 'REPORT_MESSAGE_ERROR';

export const FETCH_BLOCKED_USERS_START = 'FETCH_BLOCKED_USERS_START';
export const FETCH_BLOCKED_USERS_SUCCESS = 'FETCH_BLOCKED_USERS_SUCCESS';
export const FETCH_BLOCKED_USERS_ERROR = 'FETCH_BLOCKED_USERS_ERROR';

export const DELETE_CONVERSATION_START = 'DELETE_CONVERSATION_START';
export const DELETE_CONVERSATION_SUCCESS = 'DELETE_CONVERSATION_SUCCESS';
export const DELETE_CONVERSATION_ERROR = 'DELETE_CONVERSATION_ERROR';

export const UPDATE_MESSAGE_START = 'UPDATE_MESSAGE_START';
export const UPDATE_MESSAGE_SUCCESS = 'UPDATE_MESSAGE_SUCCESS';
export const UPDATE_MESSAGE_ERROR = 'UPDATE_MESSAGE_ERROR';

export const FETCH_MEMBERS_IN_SCOPE_START = 'FETCH_MEMBERS_IN_SCOPE_START';
export const FETCH_MEMBERS_IN_SCOPE_SUCCESS = 'FETCH_MEMBERS_IN_SCOPE_SUCCESS';
export const FETCH_MEMBERS_IN_SCOPE_ERROR = 'FETCH_MEMBERS_IN_SCOPE_ERROR';

export const FETCH_MESSAGE_START = 'FETCH_MESSAGE_START';
export const FETCH_MESSAGE_SUCCESS = 'FETCH_MESSAGE_SUCCESS';
export const FETCH_MESSAGE_ERROR = 'FETCH_MESSAGE_ERROR';

export const RESOLVE_REPORT_START = 'RESOLVE_REPORT_START';
export const RESOLVE_REPORT_SUCCESS = 'RESOLVE_REPORT_SUCCESS';
export const RESOLVE_REPORT_ERROR = 'RESOLVE_REPORT_ERROR';

export const FETCH_REPORT_START = 'FETCH_REPORT_START';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
export const FETCH_REPORT_ERROR = 'FETCH_REPORT_ERROR';


export const PAGE_SIZE = 10;
export const SANITIZE_HTML_CONFIG = {
  allowedTags: ['h1', 'h2', 'h3', 'em', 'p', 's', 'pre', 'blockquote', 'i', 'b', 'strong', 'ins', 'sup', 'sub', 'span', 'ul', 'ol', 'li', 'a', 'br', 'u', 'div', 'iframe', 'img'],
  allowedAttributes: {
    'h1':['style', 'class'],
    'h2':['style', 'class'],
    'h3':['style', 'class'],
    'p':['style', 'class'],
    's':['style', 'class'],
    'pre':['class', 'spellcheck'],
    'blockquote':['style', 'class'],
    'a':['style', 'class', 'href', 'target', 'rel', 'data-cmp-ab'],
    'span':['style', 'class'],
    'u':['style', 'class'],
    'strong':['style', 'class'],
    'em':['style', 'class'],
    'sub':['style', 'class'],
    'sup':['style', 'class'],
    'ul':['style', 'class'],
    'li':['style', 'class'],
    'ol':['style', 'class'],
    'div':['class'],
    'iframe':['class', 'frameborder', 'allowfullscreen', 'src', 'data-lf-yt-playback-inspected-lynor8xn0nq4wqjz', 'data-lf-vimeo-playback-inspected-lynor8xn0nq4wqjz', 'data-cmp-ab', 'data-cmp-info'],
    'img':['src']
  },
  allowedStyles: {
    '*': {
      'color': [/^\#(0x)?[0-9a-f]+$/i, /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(,\s*(1|0|(0?\.\d{1,2})))?\s*\)$/],
      'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/]
    },
    'span': {
      'font-size': [/^\d+(?:px|em|%)$/],
      'background-color': [/^\#(0x)?[0-9a-f]+$/i, /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(,\s*(1|0|(0?\.\d{1,2})))?\s*\)$/]
    }
  },
  allowedClasses: {
    '*': [
      'ql-size-small',
      'ql-size-large',
      'ql-size-huge',
      'ql-align-center',
      'ql-align-right',
      'ql-align-justify',
      'ql-font-serif',
      'ql-font-monospace',
      'ql-cursor'
    ],
    'pre': [
      'ql-syntax'
    ],
    'div': [
      'ql-video-wrapper'
    ],
    'iframe': [
      'ql-video'
    ]
  },
  allowedIframeHostnames: ['www.youtube.com', 'player.vimeo.com']
}

export function fetchUnreadNumber(platformId) {
  return dispatch => {
    dispatch({ type: FETCH_UNREAD_START });

    return requestApiGet(
      `/messages/${platformId}/unread`,
      null,
      null
    )
      .then(result => {
        const payload = result.result

        return dispatch({
          type: FETCH_UNREAD_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_UNREAD_ERROR,
          error
        });
      });
  };
}

export function fetchBlockedUsers() {
  return dispatch => {
    dispatch({ type: FETCH_BLOCKED_USERS_START });

    return requestApiGet(
      `/messages/blocked`,
      null,
      null
    )
      .then(result => {
        const payload = result.result

        return dispatch({
          type: FETCH_BLOCKED_USERS_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_BLOCKED_USERS_ERROR,
          error
        });
      });
  };
}


export function sendMessage(formValues, platformId) {
  return dispatch => {
    dispatch({
      type: SEND_MESSAGE_START,
    });

    if(formValues.parent_id === null) {
      delete formValues.parent_id;
    }

    const values = {
      ...formValues,
      content: sanitizeHTML(formValues.content, SANITIZE_HTML_CONFIG)
    };

    const headers = {
      ...dispatch(getSessionIp())
    };

    let url;
    if (values.content && values.subject && values.recipients)
      url = '/messages/' + platformId;
    else if (values.content && values.conversation_id)
      url = '/messages/reply'
    else {
      return dispatch({
        type: SEND_MESSAGE_ERROR,
        error: "Invalid form values"
      });
    }

    return requestApiPost(
      url,
      values,
      headers
    )
    .then(() => {
      notification.success({
        message: i18next.t('API_NOTIFICATIONS:success'),
        description: i18next.t('API_NOTIFICATIONS:message-sent')
      });
      return dispatch({ type: SEND_MESSAGE_SUCCESS });
    })
    .catch(error => {
      const description = error.description || error;
      notification.error({
        message: description
      });
      return dispatch({
        type: SEND_MESSAGE_ERROR,
        error: error
      });
    });
  };
}

export function blockUser(blockeeId) {
  return dispatch => {
    dispatch({
      type: BLOCK_USER_START,
    }); 

    return requestApiPost(
      '/messages/block',
      {blockee_id: blockeeId},
      null
    )
    .then(() => {
      notification.success({
        message: i18next.t('API_NOTIFICATIONS:success'),
        description: i18next.t('API_NOTIFICATIONS:modifications-saved')
      });
      return dispatch({ type: BLOCK_USER_SUCCESS });
    })
    .catch(error => {
      const description = error.description || error;
      notification.error({
        message: description
      });
      return dispatch({
        type: BLOCK_USER_ERROR,
        error: error
      });
    });
  };
}

export function unblockUser(blockeeId) {
  return dispatch => {
    dispatch({
      type: UNBLOCK_USER_START,
    });      

    return requestApiPost(
      '/messages/unblock',
      {blockee_id: blockeeId},
      null
    )
    .then(() => {
      notification.success({
        message: i18next.t('API_NOTIFICATIONS:success'),
        description: i18next.t('API_NOTIFICATIONS:modifications-saved')
      });
      return dispatch({ type: UNBLOCK_USER_SUCCESS });
    })
    .catch(error => {
      const description = error.description || error;
      notification.error({
        message: description
      });
      return dispatch({
        type: UNBLOCK_USER_ERROR,
        error: error
      });
    });
  };
}

export function reportMessage(messageId, reason) {
  return dispatch => {
    dispatch({
      type: REPORT_MESSAGE_START,
    });      

    return requestApiPost(
      '/messages/report',
      {message_id: messageId, reason: reason},
      null
    )
    .then(() => {
      return dispatch({ type: REPORT_MESSAGE_SUCCESS });
    })
    .catch(error => {
      return dispatch({
        type: REPORT_MESSAGE_ERROR,
        error: error
      });
    });
  };
}

export function markAsUnread(messageId) {
  return dispatch => {
    dispatch({
      type: MARK_AS_UNREAD_START,
    }); 

    return requestApiPost(
      '/messages/markAsUnread',
      {message_id: messageId},
      null
    )
    .then(() => {
      return dispatch({ type: MARK_AS_UNREAD_SUCCESS });
    })
    .catch(error => {
      return dispatch({
        type: MARK_AS_UNREAD_ERROR,
        error: error
      });
    });
  };
}

export function fetchConversation(conversationId, search, oldestFirst = false, batchNumber = 1) {
  return dispatch => {
    dispatch({ type: FETCH_CONVERSATION_START });

    return requestApiGet(
      `/messages/conversations/${conversationId}`,
      {oldestFirst: oldestFirst, batchNumber: batchNumber, search: search},
      null
    )
      .then(result => {
        const payload = {
          results: result.results,
          batchNumber: batchNumber,
          bottomReached: result.results.messages.length < PAGE_SIZE
        }

        return dispatch({
          type: FETCH_CONVERSATION_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_CONVERSATION_ERROR,
          error
        });
      });
  }
}

export function deleteConversation(conversationId) {
  return dispatch => {
    dispatch({
      type: DELETE_CONVERSATION_START,
    }); 

    return requestApiPut(
      '/messages/conversation/delete',
      {conversation_id: conversationId},
      null
    )
    .then(() => {
      return dispatch({ type: DELETE_CONVERSATION_SUCCESS });
    })
    .catch(error => {
      return dispatch({
        type: DELETE_CONVERSATION_ERROR,
        error: error
      });
    });
  };
}

export function updateMessage(messageId, statusId, content, sendEmails) {
  return dispatch => {
    dispatch({
      type: UPDATE_MESSAGE_START,
    }); 

    return requestApiPut(
      '/messages',
      {message_id: messageId, status_id: statusId, content: content !== null && content !== undefined ? sanitizeHTML(content, SANITIZE_HTML_CONFIG) : undefined, send_emails: sendEmails},
      null
    )
    .then(() => {
      notification.success({
        message: i18next.t('API_NOTIFICATIONS:success'),
        description: i18next.t('API_NOTIFICATIONS:modifications-saved')
      });
      return dispatch({ type: UPDATE_MESSAGE_SUCCESS });
    })
    .catch(error => {
      const description = error.description || error;
      notification.error({
        message: description
      });
      return dispatch({
        type: UPDATE_MESSAGE_ERROR,
        error: error
      });
    });
  };
}

export function getMembersInScope(platformId, campaignId, teamIds, memberIds, captainsOnly) {
  return dispatch => {
    dispatch({ type: FETCH_MEMBERS_IN_SCOPE_START });

    if(!campaignId && teamIds.length === 0 && memberIds.length === 0) {
      return dispatch({
        type: FETCH_MEMBERS_IN_SCOPE_SUCCESS,
        payload: []
      });
    }
  

    return requestApiGet(
      `/messages/${platformId}/membersInScope`,
      {campaignId, teamIds, memberIds, captainsOnly},
      null
    )
      .then(result => {
        const payload = result.results

        return dispatch({
          type: FETCH_MEMBERS_IN_SCOPE_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_MEMBERS_IN_SCOPE_ERROR,
          error
        });
      });
  }
}

export function getMessage(messageId) {
   return dispatch => {
    dispatch({ type: FETCH_MESSAGE_START });

    return requestApiGet(
      `/messages/get/` + messageId,
      null,
      null
    )
      .then(result => {
        const payload = result

        return dispatch({
          type: FETCH_MESSAGE_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_MESSAGE_ERROR,
          error
        });
      });
  }
}

export function resolveReport(reportId) {
  return dispatch => {
    dispatch({ type: RESOLVE_REPORT_START });

    return requestApiPost(
      `/messages/reports/resolve/` + reportId,
      null,
      null
    )
    .then(result => {
      const payload = result

      return dispatch({
        type: RESOLVE_REPORT_SUCCESS,
        payload: payload
      });
    })
    .catch(error => {
      return dispatch({
        type: RESOLVE_REPORT_ERROR,
        error
      });
    });
  }
}

export function fetchMessageReport(reportId) {
  return dispatch => {
    dispatch({ type: FETCH_REPORT_START });

    return requestApiGet(
      `/messages/reports/` + reportId,
      null,
      null
    )
      .then(result => {
        const payload = result.result

        return dispatch({
          type: FETCH_REPORT_SUCCESS,
          payload: payload
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_REPORT_ERROR,
          error
        });
      });
  }
}